import { StyleSheet } from "aphrodite";
import {
  fontSize,
  fontWeight,
} from "main/javascripts/styles/base/typographyStyle";
import {
  accentColor,
  textColor,
} from "main/javascripts/styles/base/colorStyle";
import { space } from "main/javascripts/styles/base/spaceStyle";

export interface IStyle {
  header: any;
  author: any;
  headline: any;
  authorBlock: any;
  ratingBlock: any;
  starBlock: any;
  starNum: any;
  review: any;
}

export const ReviewListStyle: IStyle = StyleSheet.create({
  header: {
    display: "flex",
    alignItems: "center",
  },
  author: {
    verticalAlign: "middle",
  },
  headline: {
    fontSize: fontSize.mediumHeading,
    color: accentColor.primaryColor,
    fontWeight: fontWeight.bold,
    textAlign: "center",
    letterSpacing: "0.2em",
  },
  authorBlock: {
    fontSize: fontSize.caption,
    lineHeight: "1",
    color: textColor.secondaryDarkColor,
  },
  ratingBlock: {
    fontSize: fontSize.title,
    textAlign: "center",
    paddingBottom: space.atom2x,
  },
  starBlock: {
    fontSize: fontSize.title,
  },
  starNum: {
    fontSize: fontSize.mediumHeading,
  },
  review: {
    paddingTop: 0,
  },
});
